/* eslint-disable react/no-array-index-key */
import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { COMPONENTS } from 'site-modules/personalized-search/constants/components';
import { SearchRenderer } from 'site-modules/personalized-search/search-renderer/search-renderer';

import 'client/site-modules/personalized-search/styles.scss';

export const Overview = memo(({ componentParams, componentPath, isMobile = false, onRendered = noop }) => {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return (
    <section>
      <div className="base-inner-width px-1 px-md-0_5 px-lg-0 mx-md-auto mb-2">
        <div className="pos-r">
          {componentParams?.map((paramsItem, idx) => (
            <SearchRenderer
              key={idx}
              componentParams={paramsItem}
              parentComponentName={COMPONENTS.OVERVIEW}
              componentPath={componentPath}
              withCollapse={componentParams.length > 1}
              isMobile={isMobile}
              order={idx + 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
});

Overview.displayName = 'Overview';

Overview.propTypes = {
  componentParams: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  componentPath: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  onRendered: PropTypes.func,
};
